module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-blue@2x-a92880ac.png";